import React from 'react'

import ApproveProjectMulti from './ApproveProjectMulti'

export default function ApproveCancelMulti() {
  return <ApproveProjectMulti />
}
